import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { getAppraiseList } from "@/api/exam";
let Appraise = class Appraise extends Vue {
    constructor() {
        super(...arguments);
        this.SELECT_VIEW_MAP = {
            1: '纸条ID',
            2: '手机号',
            3: '昵称',
        };
        this.examId = '';
        this.searchType = 1;
        this.searchMessage = '';
        this.appraiseListSearch = '';
        this.examName = '';
        this.appraiseArr = [];
        this.appraiseListPageIndex = 1;
        this.pageSize = 15;
        this.isShowLoading = true;
        this.totalData = 0;
        this.totalAppraiseCount = 0;
        this.haveAppraiseCount = 0;
        this.withoutAppraiseCount = 0;
        this.modifyFlag = false;
        this.selectGroupValue = [];
        this.selectUserIdList = [];
        this.sortBtnLoading = false;
    }
    created() {
        var query = this.$route.query;
        // this.courseId = query.courseId
        this.examId = query.exam_id;
        this.examName = query.exam_name || '';
        if (this.examId) {
            console.log("拥有 examId");
            sessionStorage.setItem('examId', this.examId);
        }
        else {
            console.log("没有 examId");
            this.examId = sessionStorage.getItem("examId");
        }
        // this.searchMessage = query.appraiseListSearch || ''
        // this.appraiseListPageIndex = Number(query.appraiseListPage) || 1
        this.requestTableData();
    }
    async requestTableData() {
        this.isShowLoading = true;
        this.appraiseListSearch = this.searchMessage;
        // this.gooseClass ? this.toRoute("gooseAppraiseList", this.eClassParams) : window.location.href = this.processHref;
        try {
            const res = await getAppraiseList({
                id: this.examId,
                keywordType: this.searchType,
                keyword: this.appraiseListSearch || void 0,
                pageNo: this.appraiseListPageIndex,
                pageSize: this.pageSize
            });
            const data = res.data.data;
            this.appraiseArr = data.list;
            this.totalData = Number(data.total);
            // this.totalAppraiseCount = i.exam_info.commit_count
            // this.haveAppraiseCount = i.exam_info.comment_count
            // this.withoutAppraiseCount = i.exam_info.commit_count - i.exam_info.comment_count
            // this.modifyFlag = i.modify_flag
        }
        catch (_) { }
        finally {
            this.isShowLoading = false;
        }
    }
    requestTableDataByIndex(pageIndex) {
        this.appraiseListPageIndex = pageIndex;
        // this.gooseClass ? this.toRoute("gooseAppraiseList", this.eClassParams) : window.location.href = this.processHref
        this.requestTableData();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.requestTableData();
    }
    preview(appraise) {
        this.$router.push({
            name: 'AppraisePreview',
            query: {
                user_id: appraise.userId,
                exam_id: this.examId,
                id: appraise.id
            }
        });
    }
};
Appraise = tslib_1.__decorate([
    Component({
        name: 'Appraise',
    })
], Appraise);
export default Appraise;
